<div class="bc-container bc-margin-bottom-4">
  <div class="bc-row">
    <div class="bc-col-12">
      <h2 id="titulo monitoreo y control">Monitoreo y Control</h2>
    </div>
  </div>
  <iframe title="Tablero SmartSupervision" [style.width.px]="iframeWidth" [style.height.px]="iframeHeight"
  [src]="powerBi"
  allowFullScreen="true" id="reporte powerBi"></iframe>
</div>